export const ENV_VARIABLES = {
    staging: {
        API_URL: "https://dev-api.transportbook.in/",
        PARENT_WEBSITE:"https://qat-site.transportbook.in/"
    },
    production: {
        API_URL: "https://api.transportbook.in/",
        PARENT_WEBSITE:"https://www.transportbook.in/"
    },
    dev: {
        API_URL: "https://staging-api.transportbook.in/",
        PARENT_WEBSITE:"http://localhost:8000/"
    }
};
export const getEnv = ()=>{
    let ENV = "dev";
    if (typeof window !== 'undefined') {
        if (['localhost:3000'].some(v=>window.location.host.includes(v))) {
            ENV ='dev';
        }else if (['qat-dweb.transportbook.in'].some(v=>window.location.host.includes(v))) {
            ENV ='staging';
        }else if (['dweb.transportbook.in'].some(v=>window.location.host.includes(v))) {
            ENV ='production';
        }else{
            ENV ='production'; 
        }
    } 
    return ENV;
}
export const PARENT_WEBSITE=()=>ENV_VARIABLES[getEnv()].PARENT_WEBSITE;
export const PARENT_WEBSITE_LOGIN=()=>ENV_VARIABLES[getEnv()].PARENT_WEBSITE+'auth?';
export const API_URL=()=>ENV_VARIABLES[getEnv()].API_URL;
